import { render, staticRenderFns } from "./GDQShortSettings.vue?vue&type=template&id=65992ae2&"
import script from "./GDQShortSettings.vue?vue&type=script&lang=js&"
export * from "./GDQShortSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports